import React, { useEffect, useState } from "react";
import BForm from "../components/forms/BForm";
import { professionsService } from "../service/professionsService";
import { regionsService } from "../service/regionsService";
import validatePlzs from "../utilis/plzsValidation";

export default function PartnersForm({
  preloadedData,
  btnText,
  onSubmit,
  responseErrors,
  success,
}) {
  const [professions, setProfessions] = useState([]);
  const [provinces, setRegions] = useState([]);

  useEffect(() => {
    professionsService.getAllProfessions().then((res) => {
      let data = res.data.map((el) => ({
        value: el.id,
        label: el.name,
      }));
      setProfessions(data);
    });
  }, []);

  useEffect(() => {
    regionsService.getAllRegions().then((res) => {
      let data = res.data.map((el) => ({
        value: el.id,
        label: el.name,
      }));
      setRegions(data);
    });
  }, []);

  const fields = [
    {
      fieldName: "companyName",
      placeholder: "Firmenname",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "logo",
      placeholder: "Logo",
      validation: {
        required: true,
      },
      type: "file",
    },
    {
      fieldName: "contactPerson",
      placeholder: "Ansprechpartner",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "province",
      placeholder: "Bezirk",
      validation: {
        required: true,
      },
      type: "select",
      options: provinces,
    },
    {
      fieldName: "address",
      placeholder: "Adresse",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "zipCodes",
      placeholder: "Postleitzahlen durch Kommas trennen",
      validation: {
        required: true,
        validate: {
          checkPlzs: v => validatePlzs(v) || "This isn't valid zip code!"
        },
      },
      type: "textarray",
    },
    {
      fieldName: "profession",
      placeholder: "Beruf",
      validation: {
        required: true,
      },
      type: "select",
      options: professions,
    },
    {
      fieldName: "price",
      placeholder: "Preis",
      validation: {
        required: true,
      },
      type: "number",
    },
    {
      fieldName: "durationFrom",
      placeholder: "Dauer von",
      validation: {
        required: true,
      },
      type: "date",
    },
    {
      fieldName: "durationTo",
      placeholder: "Dauer bis",
      validation: {
        required: true,
      },
      type: "date",
    },
    {
      fieldName: "phoneNumber",
      placeholder: "Telefonnummer",
      validation: {
        required: true,
        pattern: {
          value: /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{3})/,
          message: "Phone number isn't valid! Try (123 456 789)",
        },
      },
      type: "number",
    },
    {
      fieldName: "websiteURL",
      placeholder: "Website-URL",
      validation: {
        required: true,
      },
    },
    {
      fieldName: "note",
      placeholder: "Notizen",
    },
  ];

  return (
    <BForm
      preloadedData={preloadedData}
      btnText={btnText}
      submit={onSubmit}
      fields={fields}
      responseErrors={responseErrors}
      success={success}
    />
  );
}
